import { render, staticRenderFns } from "./WhyCoopnetComponent.vue?vue&type=template&id=448e5924&scoped=true&"
import script from "./WhyCoopnetComponent.vue?vue&type=script&lang=js&"
export * from "./WhyCoopnetComponent.vue?vue&type=script&lang=js&"
import style0 from "./WhyCoopnetComponent.vue?vue&type=style&index=0&id=448e5924&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448e5924",
  null
  
)

export default component.exports